import { useState } from "react"
import { useLocation, useNavigate, useLoaderData, useOutletContext } from "react-router-dom"
import { useAuth } from "contexts/auth-context"
import { useLayoutEffect } from "react"
import Form from "./form"
import nProgress from "nprogress"
import toast from "react-hot-toast"
import { useSWRConfig } from "swr"
import { usePage } from "contexts/page-context"
import { Transition } from "components"
import { lang } from "config"
import { getParameter } from "helpers/general-helper"
import { insertPurchaseTransaction } from "helpers/transaction-helper"

export default function Create({ title }) {
    const { user } = useAuth()
    const { cache } = useSWRConfig()

    const { setTransition } = usePage()

    const { setTitle } = useOutletContext()

    const data = useLoaderData()

    const location = useLocation()
    const navigate = useNavigate()

    const [prevRouteState, setPrevRouteState] = useState({})

    const [errors, setErrors] = useState({})
    const ppn_percentage = parseInt(getParameter("PPN_PERCENTAGE"))

    useLayoutEffect(() => {
        const getPrevRouteState = async () => {
            setPrevRouteState({
                back: location.state?.back,
                from: location.state?.from,
                transition: location.state?.transition
            })
        }

        setTransition(location.state?.transition)
        setTitle(`Create Purchase`)
        getPrevRouteState()
    }, [])

    const handleSubmit = (data) => {
        const onSuccess = (result, message) => {
            nProgress.done()
            cache.clear()
            navigate({ pathname: '/purchase' })
            toast.success("Purchase berhasil disimpan!", {
                id: "submit"
            })
        }
    
        const onError = (message) => {
            nProgress.done()
            toast.error("onError: " + message, {
                id: "submit"
            })
        }

        if (data.warehouse_name && data.supplier_name && data.warehouse_address) {
            nProgress.start()
            toast.loading("Loading", {
                id: "submit"
            })
            
            insertPurchaseTransaction(data, user?.name, onSuccess, onError)
            
        } else {
            setErrors({
                outlet_name: data.outlet_name ? undefined : lang.outlet_name + " " + lang.field_required,
                warehouse_name: data.warehouse_name ? undefined : lang.deliver_to + " " + lang.field_required,
                supplier_name: data.supplier_name ? undefined : lang.supplier_name + " " + lang.field_required,
                warehouse_address: data.warehouse_address ? undefined : lang.delivery_address + " " + lang.field_required,
            })
        }
    }

    return (
        <Transition type="fade">
            <Form data={data} errors={errors} onSubmit={handleSubmit} />
        </Transition>
    )
}